import React from 'react';
import axios from 'axios';
import { RowEditor, SectionCard } from './ProfileWidgets';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Generic section that renders a list of row configs,
 * each backed by two profile fields:  {key}_value, {key}_notes
 * (or, when `row.multi` is true:  {key}, {key}_notes array+text)
 * or (when `row.text` is true:  a single free-text {key} field).
 */
const ProfileSectionGeneric = ({
  title, subtitle, rows, profile, readOnly, onProfileUpdate, testId,
}) => {
  const saveRow = async (row, { value, notes }) => {
    const payload = {};

    if (row.text) {
      payload[row.key] = value;
    } else if (row.multi) {
      payload[row.key] = value;
      payload[`${row.key}_notes`] = notes;
    } else {
      payload[`${row.key}_value`] = value;
      payload[`${row.key}_notes`] = notes;
    }

    const res = await axios.put(`${API}/profile/me`, payload);
    onProfileUpdate(res.data);
  };

  return (
    <SectionCard title={title} subtitle={subtitle} testId={testId}>
      {rows.map(row => {
        const value = row.text
          ? profile?.[row.key]
          : row.multi
            ? (profile?.[row.key] || [])
            : profile?.[`${row.key}_value`];
        const notes = row.text ? '' : (profile?.[`${row.key}_notes`] || '');

        // In read view, hide rows that have no value set.
        if (readOnly) {
          const hasValue = row.multi
            ? Array.isArray(value) && value.length > 0
            : !!(value && value.toString().trim());
          if (!hasValue) return null;
        }

        return (
          <RowEditor
            key={row.key}
            icon={row.icon}
            label={row.label}
            options={row.options || []}
            value={value}
            notes={notes}
            multi={!!row.multi}
            text={!!row.text}
            maxLength={row.maxLength}
            placeholder={row.placeholder}
            readOnly={readOnly}
            onSave={(payload) => saveRow(row, payload)}
          />
        );
      })}
      {readOnly && rows.every(row => {
        const v = row.text ? profile?.[row.key] : row.multi ? profile?.[row.key] : profile?.[`${row.key}_value`];
        const has = row.multi ? Array.isArray(v) && v.length > 0 : !!(v && v.toString().trim());
        return !has;
      }) && (
        <div className="text-sm text-charcoal/30 italic py-2">Nothing shared yet.</div>
      )}
    </SectionCard>
  );
};

export default ProfileSectionGeneric;
